import { FormGroup, FormControl, } from '@angular/forms';
import { Component, ViewChildren, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { Hip2ManagementService } from 'src/app/shared/services/hip2-management.service';
import { ApiList } from '../models/api-list';
import { Subject, Subscription, debounceTime, timer } from 'rxjs';
import { DateFormatPipe } from 'src/app/pipes/date-format-pipe.pipe';
import { Environment } from 'src/environments/environment';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ToastService } from 'src/app/shared/services/toast.service';


@Component({
  selector: 'app-manage-api',
  templateUrl: './manage-api.component.html',
  styleUrls: ['./manage-api.component.scss'],
  providers: [DateFormatPipe]
})
export class ManageApiComponent implements OnDestroy {
  loaderEnabled: boolean = true;
  searchApivalue: string = '';
  gridArray: any[] = []; // type of gridArray is any as we need to pass that to generic table component
  selectedBusinessvalue: string[] = []; // for maintaining state of business Area filters
  dataKeys: string[] = [];
  pageNo: number = 1;
  itemsPerPage: number = 10;
  filterForm: FormGroup = new FormGroup({});
  businessFilter: FormControl = new FormControl('');
  totalRecordCount: number = 0;
  isSearchBusinessFilterEnabled: boolean = false;
  tableInfo: string = "APIs"
  enableColonDateFormat: boolean = false;
  apiTableHeaderList: string[] = [
    "API Name",
    "Version",
    "Business Area",
    "API Owner",
    "Date Registered",
    "Actions"
  ];

  applicationDetailHeaderList: string[] = [
    "Application Number",
    "Application Name",
    "Application Owner"
  ]

  businessAreaList = [
    {
      'id': '1',
      'label': 'CT'
    },
    {
      'id': '2',
      'label': 'CO'
    },
    {
      'id': '3',
      'label': 'IT'
    },
    {
      'id': '4',
      'label': 'PT'
    },
    {
      'id': '5',
      'label': 'VT'
    }
  ];

  sortingHeaderList = [{ head: 'API Name', key: 'apiName' }, { head: 'Version', key: 'version' }, { head: 'Business Area', key: 'businessArea' }
    , { head: 'API Owner', key: 'apiOwner' }, { head: 'Date Registered', key: 'dateRegistered' }, { head: 'Activated Date', key: 'activatedDate' }]

  searchAPISubscription!: Subscription;
  searchAPIValueChanged: Subject<string> = new Subject<string>();
  @ViewChildren('contentSection') contentSections!: ElementRef[];
  @ViewChildren('bodyWrapper') bodyWrapper!: ElementRef[];
  sectionHeight = 0;
  deleteAPIMessage: string = '';
  deleteAlertAPIMessage: string = '';
  deleteAlertInfoMessage: string = "";
  showSuccess: boolean = false;
  showFailure: boolean = false;
  successMsg: string = '';
  failureMsg: string = '';
  selectedapiId: string = ""
  selectedapiName: string = ""
  loaderActive: boolean = false
  workbookLink: string = ""
  // listen for window resize events
  @HostListener('window:resize')
  onResize() {
    this.setContentSectionHeight();
  }
  setContentSectionHeight() {
    const windowHeight = window.innerHeight;
    if (this.contentSections != undefined) {
      this.contentSections.forEach(section => {
        const offsetTop = section.nativeElement.getBoundingClientRect().top;
        const sectionHeight = windowHeight - Math.floor(offsetTop) - (window.innerWidth * 0.0052 * 4.8);
        //0.0052 is the constant value which will be used as dynamic value changing for font-size and 4.8 is the height of footer in rem  
        section.nativeElement.style.minHeight = `${Math.floor(sectionHeight)}px`;
      });
    }
  }

  constructor(private hipManagementService: Hip2ManagementService, private dateFormatPipe: DateFormatPipe, private modal: ModalService, private toaster: ToastService) { }

  public renderPageValue(value: number) {
    this.showSuccess = false;
    this.showFailure = false;
    this.itemsPerPage = value;
    this.pageNo = 1;
    this.loadApiList()
  }

  ngOnInit(): void {
    this.getWorkbookLink();
    // this.loadApiList();
    this.toaster.showFailure$.subscribe(value => {
      this.showFailure = value
    })
    this.toaster.showSuccess$.subscribe(value => {
      this.showSuccess = value
    })
    this.filterForm = new FormGroup({
      filter: this.businessFilter
    });
    this.controlDataChange();
    this.modal.register('delete_api');
    this.modal.register('delete_api_alert');
  }

  getWorkbookLink() {
    this.hipManagementService.getWorkbookLinks("API", Environment.environment).subscribe({
      next: (link: any) => {
        this.workbookLink = link.url
        this.loadApiList();
      },
      error: (err: string) => {
        console.log("Error response " + err); this.loaderEnabled = false;
        this.loadApiList();
      }
    })
  }

  ngAfterContentInit(): void {
    this.searchAPISubscription = this.searchAPIValueChanged.pipe(debounceTime(1500)).subscribe(value => {
      this.searchApivalue = value;
      if (this.searchApivalue.length > 2 || this.searchApivalue.length == 0) {
        this.pageNo = 1;
        this.loadApiList();
        this.setContentSectionHeight();
      }
    })
    this.setContentSectionHeight();
  }
  controlDataChange() {
    this.businessFilter.valueChanges.subscribe((businessFilterObject) => {
      let businessValue = businessFilterObject.map((obj: any) => { return obj.label });
      this.selectedBusinessvalue = businessValue;
      this.loadApiList();
    });
  }

  onTablePage(event: any) {
    this.showSuccess = false;
    this.showFailure = false;
    this.pageNo = event;
    this.loadApiList()
  }
  loadApiList() {
    let filter = (this.searchApivalue.trimStart()).trimEnd();
    let sortDirection = 'asc';
    let pageIndex = this.pageNo;
    let pageSize = this.itemsPerPage;
    let businessAreaCode = '';
    //get the selected business code
    this.selectedBusinessvalue.forEach(element => {
      businessAreaCode = businessAreaCode.length == 0 ? element : (businessAreaCode + ',' + element)
    }); this.loaderEnabled = true;
    this.hipManagementService.getApis(filter, sortDirection, pageIndex, pageSize, businessAreaCode).subscribe({
      next: (apiData: ApiList) => {
        this.gridArray = [];
        apiData.apiDetails.forEach(apiDetail => {
          let apiName = apiDetail.apimApiName;
          let azureWorkBookLink: String = this.workbookLink.includes("{{apiName}}") ? this.workbookLink.replace("{{apiName}}", apiName) : ""
          let applicationInformation = {
            "applicationNumber": apiDetail.cmdbId,
            "applicationName": apiDetail.applicationName,
            "applicationOwner": apiDetail.applicationOwner
          }
          let childTableData = [applicationInformation];
          let api = {
            "uniqueId": apiDetail.apimApiName,
            "apiName": apiDetail.apiDisplayName,
            "version": apiDetail.version,
            "businessArea": apiDetail.businessAreaCode,
            "apiOwner": apiDetail.apiOwner,
            "dateRegistered": apiDetail.activatedOn == undefined ? "" : this.dateFormatPipe.transform(apiDetail.activatedOn, this.enableColonDateFormat),
            "Action":
            {
              "edit": "/publisher/manage-apis/edit-api/" + apiDetail.apimApiName,
              "info": "/publisher/manage-apis/view-api/" + apiDetail.apimApiName,
              "delete": true,
              "azureDashboardLink": azureWorkBookLink ? azureWorkBookLink : ""
            },
            "detail": {
              "headings": this.applicationDetailHeaderList,
              "tableData": childTableData
            }
          }
          this.gridArray.push(api);
        });
        if (this.gridArray.length > 0) {
          this.dataKeys = Object.keys(this.gridArray[0]);
          this.dataKeys.splice(this.dataKeys.indexOf("detail", 1))
        }
        this.loaderEnabled = false;
        this.totalRecordCount = apiData.totalCount;
        this.resetScroll();
        this.setContentSectionHeight();
      },
      error: (err: string) => {
        console.log("Error response " + err); this.loaderEnabled = false;
        this.setContentSectionHeight();
      }
    })
  }

  apiSearch(apiValue: string) {
    this.showSuccess = false;
    this.showFailure = false;
    this.searchAPIValueChanged.next(apiValue)
  }
  resetScroll() {
    const BodyElement: HTMLElement | null = document.getElementById('bodyContent');
    if (BodyElement != null) {
      BodyElement.scrollTop = 0;
    }
  }
  onDropdownClick() {
    this.showSuccess = false;
    this.showFailure = false;
  }
  clearSearch() {
    this.showSuccess = false;
    this.showFailure = false;
    if (this.searchApivalue.length > 2) {
      this.searchAPIValueChanged.next("")
    }
    this.searchApivalue = "";
  }

  onDeleteClick(data: any) {
    this.showSuccess = false;
    this.showFailure = false
    this.validateAPI(data)
  }

  onWorkbookClick(data: any) {
    this.showSuccess = false;
    this.showFailure = false
  }

  validateAPI(event: any) {
    this.loaderActive = true
    this.selectedapiId = event?.uniqueId ?? "";
    this.selectedapiName = event.apiName
    this.hipManagementService.deleteAPIValidation(this.selectedapiId).subscribe({
      next: data => {
        this.loaderActive = false
        if (data.status === 400) {
          this.modal.toggleModal("delete_api_alert");
          if (data.staticMessage === "because it is currently associated with a Product:") {
            this.deleteAlertAPIMessage =
              `You can't delete the following API:<br><em>${this.selectedapiName}</em><br>` +
              `${data.staticMessage}<br>` +
              `<em>${data.dynamicMessage}</em>` + `&nbsp;`;
          } else {
            this.deleteAlertAPIMessage =
              `You can't delete the following API:<br><em>${this.selectedapiName}</em><br>` +
              `${data.staticMessage}` +
              ` <em>${data.dynamicMessage}</em>` + `&nbsp;`;
          }
          this.deleteAlertInfoMessage = data.infoMessage;
        } else {
          this.deleteAPIMessage = `You are about to delete the following API:<br><em>` + this.selectedapiName + `</em><br>Do you want to proceed?&nbsp`;
          this.deleteAlertInfoMessage = data.infoMessage;
          this.modal.toggleModal('delete_api');
        }
      },
      error: err => {
        console.error(err);
        this.showSuccess = false;
        this.loaderActive = false;
        this.failureMsg = this.selectedapiName + " deletion failed with exception: " + err.error;
        this.showFailure = true;
        // timer(5000).subscribe((x) => this.showFailure = false)
      }
    })
  }

  onDeleteAPI(event: any) {
    if (event) {
      this.loaderActive = true
      this.hipManagementService.deleteAPI(this.selectedapiId).subscribe({
        next: data => {
          console.log(data, "data")
          this.showFailure = false;
          this.loaderActive = false;
          this.successMsg = this.selectedapiName + ' has been successfully deleted, but its DevOps repository remains in your DevOps organization for your manual removal.';
          this.showSuccess = true;
          this.loadApiList()
          timer(5000).subscribe((x) => this.showSuccess = false)
        },
        error: err => {
          console.error(err);
          this.showSuccess = false;
          this.loaderActive = false;
          this.failureMsg = this.selectedapiName + " deletion failed with exception: " + err.error;
          this.showFailure = true;
          // timer(5000).subscribe((x) => this.showFailure = false)
        }
      })
    }
  }

  oncloseToast(event: any) {
    if (event) {
      if (this.showFailure) {
        this.showFailure = false
      }
      if(this.showSuccess){
        this.showSuccess = false
      }
    }
  }

  ngOnDestroy(): void {
    this.modal.unRegister('delete_api');
    this.modal.unRegister('delete_api_alert');
  }

}
